import React, { useEffect, Suspense, lazy, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { SocialProofPopup } from './components/SocialProofPopup';
const PainSection = lazy(() => import('./components/PainSection').then(m => ({
  default: m.PainSection
})));
const SectionDivider = lazy(() => import('./components/SectionDivider').then(m => ({
  default: m.SectionDivider
})));
const MechanismSection = lazy(() => import('./components/MechanismSection').then(m => ({
  default: m.MechanismSection
})));
const TriangleSection = lazy(() => import('./components/TriangleSection').then(m => ({
  default: m.TriangleSection
})));
const ProductSection = lazy(() => import('./components/ProductSection').then(m => ({
  default: m.ProductSection
})));
const TestimonialsSection = lazy(() => import('./components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const ForWhomSection = lazy(() => import('./components/ForWhomSection').then(m => ({
  default: m.ForWhomSection
})));
const FAQSection = lazy(() => import('./components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const UrgencySection = lazy(() => import('./components/UrgencySection').then(m => ({
  default: m.UrgencySection
})));
const ClosingCTA = lazy(() => import('./components/ClosingCTA').then(m => ({
  default: m.ClosingCTA
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
export function App() {
  useEffect(() => {
    // Facebook Pixel - manual injection
    const pixelId = '1287603379450199';
    const w = window as any;
    if (w.fbq) return;
    const n: any = w.fbq = function (...args: any[]) {
      n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
    };
    if (!w._fbq) w._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    w.fbq('init', pixelId);
    w.fbq('track', 'PageView');
    // Facebook domain verification meta tag
    const meta = document.createElement('meta');
    meta.name = 'facebook-domain-verification';
    meta.content = 'l938w3cbwwi31gbhepzzrg02olc8cy';
    document.head.appendChild(meta);
  }, []);
  return <div className="w-full min-h-screen bg-brand-bg text-white font-sans" data-id="element-0">
      <SocialProofPopup data-id="element-1" />
      <HeroSection data-id="element-2" />

      <Suspense fallback={null} data-id="element-3">
        <PainSection data-id="element-4" />
        <SectionDivider data-id="element-5" />
        <MechanismSection data-id="element-6" />
        <SectionDivider data-id="element-7" />
        <TriangleSection data-id="element-8" />
        <SectionDivider data-id="element-9" />
        <ProductSection data-id="element-10" />
        <SectionDivider data-id="element-11" />
        <TestimonialsSection data-id="element-12" />
        <SectionDivider data-id="element-13" />
        <ForWhomSection data-id="element-14" />
        <SectionDivider data-id="element-15" />
        <FAQSection data-id="element-16" />
        <SectionDivider data-id="element-17" />
        <UrgencySection data-id="element-18" />
        <ClosingCTA data-id="element-19" />
        <Footer data-id="element-20" />
      </Suspense>
    </div>;
}